module.exports = __webpack_public_path__ + "static/media/fcc-logo.3b50d3c2.png";